// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2fffef39","239":"532902d7","355":"b1f23fa9","403":"2a7c38f5","453":"50894fa6","667":"6a863657","762":"f4b4a633"}[chunkId] + ".chunk.js";
};